<template>
    <div class="special-box">
        <div class="special-box-bg">
        </div>
        <el-row class="special-box-common special-box-special">
            <h3>
                <span></span>
                什么是高校专项计划
                <span></span>
            </h3>
            <p>高校专项计划，是国家为更好地促进教育公平、让更多的农村学生上大学而出台的一项优惠政策，主要招收边远、贫困、民族等地区县(含县级市)以下高中勤奋好学、成绩优良的农村学生，具体实施区域由有关省(区、市)确定。</p>
        </el-row>
        <el-row class="special-box-common special-box-reason">
            <h3>
                <span></span>
                为何要填报高校专项
                <span></span>
            </h3>
            <el-row type="flex" justify="space-between">
                <el-col>
                    <img src="../../assets/images/special-icon1.png">
                    <h4>优势1</h4>
                    <p>
                        高校专项计划促进了教育公平，
                        <span>为农村同学提供了很多入学机会。</span>    
                    </p>
                </el-col>
                <el-col>
                    <img src="../../assets/images/special-icon2.png">
                    <h4>优势2</h4>
                    <p>
                        高校专项计划政策优惠力度很大，基本上可以
                        <span>比投档分数线低30分左右</span> 
                        的成绩考入高校，这就能使教育水平比较低的偏远地区的同学可以有改变自己人生的机会。   
                    </p>
                </el-col>
            </el-row>
        </el-row>
        <el-row class="special-box-common special-box-student">
            <h3>
                <span></span>
                报考条件
                <span></span>
            </h3>
            <el-row type="flex" justify="space-between" class="special-box-student-list">
                <el-col>
                    <img src="../../assets/images/spacial-student1.png">
                    <p>边远、贫困、民族等地区县（含县级市）以下高中勤奋好学、成绩优良的农村学生</p>
                </el-col>
                <el-col>
                    <img src="../../assets/images/spacial-student2.png">
                    <p>考生本人及父亲或母亲或法定监护人户籍地在实施区域的农村</p>
                </el-col>
                <el-col>
                    <img src="../../assets/images/spacial-student3.png">
                    <p>考生本人具有当地连续三年以上户籍。本人具有户籍所在县高中连续三年学籍并实际就读</p>
                </el-col>
            </el-row>
        </el-row>
        <el-row class="special-box-common special-box-area">
            <h3>
                <span></span>
                河南省高校专项实施区域
                <span></span>
            </h3>
            <h4>（ 53个县 ）</h4>
            <el-row class="special-box-area-list" type="flex" justify="space-between">
                <el-col v-for="(item,index) in areaList" :key="index">{{item}}</el-col>
            </el-row>
        </el-row>
        <el-row class="special-box-common special-box-tips">
            <h3>
                <span></span>
                报考流程
                <span></span>
            </h3>
            <el-row class="special-box-tips-list" type="flex" justify="space-between">
                <el-col v-for="(item,index) in tipsList" :key="index" :class="index%2!=0?'special-box-tips-item':''">
                    <div class="special-box-tips-title" :class="index==0?'special-box-tips-title-diff':''">
                        {{item.desc}}
                    </div>
                    <div class="special-box-tips-line"></div>
                    <div class="special-box-tips-arrow">
                        <div class="special-box-tips-arrow1"></div>
                        <div class="special-box-tips-time">{{item.time}}</div>
                        <div class="special-box-tips-arrow2"></div>
                    </div>
                </el-col>
            </el-row>
        </el-row>
        <el-row class="special-box-common special-box-question">
            <h3>
                <span></span>
                申报难点
                <span></span>
            </h3>
            <h4>
                为什么要选择专业机构进行高校专项计划？
            </h4>
            <el-row class="special-box-question-list" type="flex">
                    <div class="special-box-question-item">
                        <img src="../../assets/images/special-nan-icon2.png">
                        <h4>难点一</h4>
                        <p>申报院校的梯度需要合理搭配</p>
                    </div>
                    <div class="special-box-question-item special-box-question-item-diff1">
                        <img src="../../assets/images/special-nan-icon3.png">
                        <h4>难点二</h4>
                        <p>准备材料繁多复杂</p>
                    </div>
                    <div class="special-box-question-item special-box-question-item-diff2">
                        <img src="../../assets/images/special-nan-icon1.png">
                        <h4>难点三</h4>
                        <p>细节问题较多<br>容易错失机会</p>
                    </div>
            </el-row>
        </el-row>
        <el-row class="special-box-common special-box-liu">
            <h3>
                <span></span>
                服务流程
                <span></span>
            </h3>
            <img src="../../assets/images/special-liu-icon.png">
        </el-row>
        <el-row class="special-box-common special-box-you">
            <h3>
                <span></span>
                服务优势
                <span></span>
            </h3>
            <el-row class="special-box-you-list" type="flex" justify="space-between">
                <el-col v-for="(item,index) in youList" :key="index">
                    <img :src="item.src">
                    <div>
                        <h4>{{item.title}}</h4>
                        <p>{{item.desc}}</p>
                    </div>
                </el-col>
            </el-row>
            <el-row class="special-box-infor special-box-order">
                <img src="../../assets/images/channel-order.png" alt="">
                <div>
                    <span class="special-box-order-title">预约专家 免费咨询</span>
                    <span class="special-box-order-desc">留下联系方式，立即与专家一对一</span>
                </div>
                <el-row>
                    <el-form :inline="true" :model="formInline" class="order-form-inline" :rules="rules" ref="formInline">
                        <el-form-item label="姓名：" prop="username">
                            <el-input v-model="formInline.username" placeholder="请输入姓名"></el-input>
                        </el-form-item>
                        <el-form-item label="电话：" prop="phone">
                            <el-input v-model="formInline.phone" placeholder="请输入电话"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="addSubscribeHandler" v-click-with-auth-login>提交</el-button>
                        </el-form-item>
                    </el-form>
                </el-row>
            </el-row>
        </el-row>
    </div>
</template>

<script>
import { addSubscribe } from '@/api/user'
export default {
    data() {
        const validateUsername = (rule, value, callback) => {
            if (!value) {
                callback(new Error("请输入姓名"));
            } else {
                callback();
            }
        };
        const validatePhone = (rule, value, callback) => {
            if (!value) {
                callback(new Error("请输入电话"));
                } else {
                if ((/^1[34578]\d{9}$/.test(value))) {
                    callback();
                } else {
                    callback(new Error("请输入正确的电话"));
                }
            }
        };
        return {
            areaList: ['兰考县','栾川县','嵩县','洛宁县','汝阳县','宜阳县','鲁山县','滑县','封丘县','范县','台前县','卢氏县','南召县','镇平县','内乡县','淅川县','社旗县','桐柏县','民权县','宁陵县','柘城县','睢县','虞城县','光山县','新县','商城县','固始县','淮滨县','潢川县','淮阳县','沈丘县','太康县','商水县','郸城县','新蔡县','上蔡县','确山县','平舆县','伊川县','叶县','内黄县','原阳县','濮阳县','舞阳县','方城县','夏邑县','罗山县','息县','西华县','扶沟县','泌阳县','正阳县','汝南县','…'],
            tipsList:[
                {desc:'有关高校公布招生简章，考生完成报名申请',time:'4月25日前'},
                {desc:'省市完成考生基本条件审核并公示通过审核名单',time:'5月20日前'},
                {desc:'高校完成考生其他条件审核并公示通过审核名单',time:'5月底前'},
                {desc:'考生参加全国统一高考',time:'6月7日-8日'},
                {desc:'部分试点高校组织考核',time:'高考后-出分前'},
                {desc:'高校确定并公示资格名单',time:'高考出分前'},
                {desc:'考生单独填报志愿，高校完成录取并公示',time:'高考出分后'},
            ],
            youList:[
                {src:require('../../assets/images/special-you-icon1.png'),title:'团队保障',desc:'荔枝新高考顶级专家团队全程跟踪,一对一线上线下规划指导'},
                {src:require('../../assets/images/special-you-icon2.png'),title:'流程保障',desc:'专项计划申请一站式服务、院校选择、材料准备自荐信指导等'},
                {src:require('../../assets/images/special-you-icon3.png'),title:'品牌保障',desc:'可靠的品牌支撑，实力、可信、靠谱'},
            ],
            formInline: {
                username: '',
                phone: '',
                type: '6'
            },
            rules: {
                username: [
                    { trigger: 'blur', validator: validateUsername },
                ],
                phone: [
                    { trigger: 'blur', validator: validatePhone },
                ],
            }
        };
    },

    mounted() {
        
    },

    methods: {
        addSubscribeHandler() {
            let that = this;
            this.$refs.formInline.validate((valid) => {
                if(valid) {
                    addSubscribe(that.formInline).then(res => {
                        this.$message({
                            message: '提交成功',
                            type: 'success'
                        });
                    })
                }
            })
        }
    },
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/variables.scss';
$font-family: 'MicrosoftYaHei';
 @font-face {
    font-family: 'zihun443hao';
    src: url('../../assets/fonts/zihun443hao.ttf');
}
$width: 1200px;
$margin: 0 auto;
    .special-box-bg {
        height: 767px;
        background: url('../../assets/images/special-bg.jpg') no-repeat center;
        width: 100%;
        background-size: cover;
        background-origin: border-box;
    }
    .special-box-common {
        h3 {
            font-size: 40px;
            font-family:$font-family;
            font-weight: 700;
            text-align: center;
            color: #332e2c;
            line-height: 52px;
            letter-spacing: 4px;
            margin: 0;
            padding: 0;
            span {
                display: inline-block;
                width: 5px;
                height: 27px;
                background: linear-gradient(180deg,#b356ff, #856eff 99%);
                border-radius: 8px;
                position: relative;
                transform:rotate(30deg);
            }
        }
    }
    .special-box-special {
        height: 290px;
        width: $width;
        margin: $margin;
        background: rgba(255,255,255,0.92);
        border-radius: 20px;
        box-shadow: 0px 8px 20px 0px rgba(24,12,125,0.06), 0px 1.5px 0px 0px rgba(255,255,255,0.56) inset; 
        backdrop-filter: blur(6px);
        padding: 44px 57px;
        box-sizing: border-box;
        margin-top: -300px;
        p {
            font-size: 22px;
            font-weight: 400;
            color: #2c3331;
            line-height: 44px;
            margin-top: 26px;
        }
    }
    .special-box-reason {
        margin: $margin;
        width: 1150px;
        h3 {
            margin: 57px 0 67px 0;
        }
        .el-col {
            width: 520px;
            height: 486px;
            background: #f7f6ff;
            border-radius: 20px;
            padding: 60px 42px;
            box-sizing: border-box;
            text-align: center;
            h4 {
                font-size: 32px;
                font-family: $font-family;
                font-weight: 700;
                color: #332e2c;
                line-height: 44px;
                margin: 24px 0 20px 0;
            }
            p {
                font-size: 22px;
                font-weight: 400;
                color: #66605e;
                line-height: 40px;
                text-align: left;
                span {
                    color: #6150E9;
                }
            }
        }
    }
    .special-box-student {
        height: 567px;
        background: #f7f6ff;
        margin-top: 80px;
        h3 {
            margin: 48px 0 58px 0;
        }
        .special-box-student-list {
            width: $width;
            margin: $margin;
            .el-col {
                width: 352px;
                p {
                    font-size: 22px;
                    font-weight: 400;
                    color: #2c3331;
                    line-height: 40px;
                    margin-top: 24px;
                }
            }
        }
    }
    .special-box-area {
        height: 641px;
        background: url('../../assets/images/special-area.jpg') no-repeat center;
        width: 100%;
        background-size: cover;
        h3 {
            color: #fff;
            margin: 48px 0 0 0;
        }
        h4 {
            width: 310px;
            height: 44px;
            background: #f68cff;
            border-radius: 22px;
            font-size: 26px;
            font-family: $font-family;
            font-weight: 700;
            text-align: center;
            color: #ffffff;
            line-height: 44px;
            margin: 0 auto;
            margin-top: 24px;
            margin-bottom: 28px;
        }
        .special-box-area-list {
            width: $width;
            margin: $margin;
            flex-wrap: wrap;
            .el-col {
                width: 123px;
                height: 52px;
                background: #ffffff;
                border-radius: 8px;
                font-size: 20px;
                font-weight: 600;
                text-align: center;
                color: #6150e9;
                line-height: 52px;
                margin-bottom: 12px;
            }
        }
    }
    .special-box-tips {
        height: 654px;
        background: #f7f6ff;
        h3 {
            margin-top: 48px;
        }
        .special-box-tips-list {
            width: $width;
            margin: $margin;
            margin-top: 64px;
            .el-col {
                position: relative;
            }
        }
        .special-box-tips-line {
            width: 1px;
            height: 24px;
            border-left: 2px dashed #bcb4ff;
            position: relative;
            left: 47%;
            transform: translateX(-50%);
        }
        .special-box-tips-title {
            width: 190px;
            height: 136px;
            background: #ffffff;
            border-radius: 8px;
            font-size: 20px;
            font-weight: 400;
            color: #2c3331;
            line-height: 32px;
            padding: 20px 23px;
            box-sizing: border-box;
            margin-right: -30px;
            position: relative;
            left: -20px;
        }
        .special-box-tips-title-diff {
            left: 0;
        }
        .special-box-tips-arrow {
            position: relative;
        }
        .special-box-tips-time {
            position: absolute;
            font-size: 20px;
            font-weight: 600;
            color: #6150e9;
            z-index: 99;
            width: 100%;
            // margin: 0 auto;
            top: 0;
            left: 0;
            text-align: center;
            line-height: 80px;
            // transform: translate(-25%,-50%);
        }
        .special-box-tips-arrow1 {
            width: 162px;
            height: 40px;
            -webkit-transform: skew(30deg);
            -moz-transform: skew(30deg);
            -o-transform: skew(30deg);
            background: #e7e4ff;
            border-radius: 0px 8px 0px 8px 0px 0px;
        }
        .special-box-tips-arrow2 {
            width: 162px;
            height: 40px;
            -webkit-transform: skew(-30deg);
            -moz-transform: skew(-30deg);
            -o-transform: skew(-30deg);
            background: #e7e4ff;
            border-radius: 0px 8px 0px 8px 0px 0px;
        }
        .special-box-tips-item {
            position: relative;
            .special-box-tips-line {
                position: relative;
                top: 105px;
            }
            .special-box-tips-title {
                position: relative;
                top: 265px;
                left: -10px;
            }
        }
    }
    .special-box-question {
        background: url('../../assets/images/special-nan.jpg') no-repeat center;
        background-size: cover;
        height: 720px;
        h3 {
            color: #fff;
            margin-top: 48px;
        }
        h4 {
            font-size: 26px;
            font-family: $font-family;
            font-weight: 700;
            text-align: center;
            color: #cd6cff;
            line-height: 35px;
            letter-spacing: 2.6px;
            margin: 18px 0 51px 0;
        }
        .special-box-question-list {
            width: 1088px;
            height: 447px;
            margin: $margin;
            margin-top: 51px;
            position: relative;
            background: url('../../assets/images/special-question-bg.png') no-repeat;
            background-size: 100% 100%;
            left: 50px;
            .el-col {
                width: 330px;
                height: 330px;
                border: 1px solid #54526b;
                border-radius: 38px;
                transform: rotateZ(45deg);
                text-align: center;
                position: relative;
                overflow: hidden;
            }
            .special-box-question-item {
                width: 320px;
                height: 320px;
                text-align: center;
                font-family: $font-family;
                box-sizing: border-box;
                position: relative;
                left: 65px;
                top: 70px;
                padding: 0 70px;
                box-sizing: border-box;
                img {
                    margin-top: 30px;
                }
                h4 {
                    font-size: 32px;
                    font-weight: 700;
                    text-align: center;
                    color: #6150e9;
                    line-height: 42px;
                    letter-spacing: 3.2px;
                    margin: 34px 0 20px 0;
                }
                p {
                    font-size: 22px;
                    font-weight: 400;
                    text-align: center;
                    color: #3d3b50;
                    line-height: 32px;
                    margin: 0;
                }
            }
        }
    }
    .special-box-liu {
        background: url('../../assets/images/special-liu-bg.jpg') no-repeat center;
        height: 807px;
        background-size: cover;
        text-align: center;
        h3 {
            margin-top: 48px;
        }
        img {
            margin: $margin;
            margin-top: 49px;
            
        }
    }
    .special-box-you {
        background: url('../../assets/images/special-you-bg.jpg') no-repeat center;
        background-size: cover;
        height: 1011px;
        margin-bottom: -56px;
        h3 {
            margin-top: 48px;
        }
        .special-box-you-list {
            width: $width;
            margin: $margin;
            .el-col {
                width: 351px;
                position: relative;
                img {
                        position: relative;
                        left: 50%;
                        transform: translateX(-50%);
                        top: 63px;
                        z-index: 99;
                    }
                div {
                    width: 351px;
                    height: 326px;
                    background: #ffffff;
                    border-radius: 20px;
                    box-shadow: 0px 1.5px 0px 0px rgba(255,255,255,0.56) inset; 
                    backdrop-filter: blur(6px);
                    font-family: $font-family;
                    padding: 43px;
                    box-sizing: border-box;
                    h4 {
                        font-size: 30px;
                        font-weight: 700;
                        text-align: center;
                        color: #2c3331;
                        line-height: 36px;
                        margin-bottom: 24px;
                        margin-top: 50px;
                    }
                    p {
                        font-size: 22px;
                        font-weight: 400;
                        color: #5e6663;
                        line-height: 40px;
                        margin: 0;
                    }
                }
            }
        }
        .special-box-order {
            @include gwidth;
            width: 1200px;
            height: 255px;
            background: linear-gradient(180deg,#ff9e4a, $common-color);
            border-radius: 20px;
            box-shadow: 0px 8px 30px 0px rgba(255,97,26,0.38);
            padding: 48px;
            margin-top: 110px;
            position: relative;
            margin-bottom: 28px;
            span {
                display: inline-block;
            }
            img {
                position: absolute;
                top:0;
                left: 0;
            }
            .special-box-order-title {
                font-size: 36px;
                font-family: 'zihun443hao';
                color: #ffffff;
            }
            .special-box-order-desc {
                font-size: 18px;
                font-weight: 500;
                color: #ffffff;
                margin-left: 24px;
            }
        }
    }
</style>